import { User } from '@auth0/auth0-react'
import { parseStringAsBool } from '~/utils/string'
import {
  DeploymentMode,
  MultiFrontendContext,
  parseDeploymentMode,
} from '../MultiFrontendContext'

const makeFrontendContextFromAuth0User = (user: User): MultiFrontendContext => {
  const getHomePage: Record<DeploymentMode, string> = {
    cloud: '/monitor',
    automation: '/workcell',
    on_prem_agent: '/data-ingestors',
    hybrid: '/monitor', // arbitrarily default to workcell for testing reasons
  }
  const defaultEnabledPages: Record<DeploymentMode, string[] | 'all'> = {
    cloud: ['monitor'],
    automation: ['workcell'],
    on_prem_agent: ['on_prem_agent'],
    hybrid: 'all', // for dev testing, default to all
  }
  // Note: Historically, the slack integration has always been enabled by default
  const defaultEnabledIntegrations = ['slack']
  const deploymentMode =
    parseDeploymentMode(process.env.MONOMER_FRONTEND_DEPLOYMENT_MODE) || 'cloud'
  const cloudFrontend =
    deploymentMode === 'hybrid'
      ? 'http://localhost:3000'
      : user.org_monomer_cloud_frontend

  // TODO(SWE=1274): OrgMetadata and userMetadata will be populated with localized hooks after
  //  Auth0 migration is complete.
  return {
    deploymentMode: deploymentMode,
    homePage: getHomePage[deploymentMode],
    monitorEnabled: true,
    useCoreAuth: false,
    cloudFrontend,
    // TODO(SWE-1291): Figure out how to make this work for dev-mode.
    demoUseLocalAssets: parseStringAsBool(
      process.env.MONOMER_USE_LOCAL_ASSETS_FOR_DEMO,
    ),
    orgMetadata: {
      automationEnabledIntegrations:
        user.org_monomer_automation_enabled_integrations || defaultEnabledIntegrations,
      automationFrontend: user.org_monomer_automation_frontend,
      enabledPages:
        user.org_monomer_enabled_pages || defaultEnabledPages[deploymentMode],
    },
    userMetadata: {
      name: user.name || '',
      picture: user.picture || '',
      email: user.email || '',
      orgDisplayName: user.org_display_name || '',
      roles: user.authz_roles || [],
    },
  }
}

export default makeFrontendContextFromAuth0User
